export const UPLOAD_FILE_TO_LOCAL_STORAGE = 'UPLOAD_FILE_TO_LOCAL_STORAGE';

